module.exports = __webpack_public_path__ + "static/media/arrow_right_gray.6d776d17.svg";